import Button, { ButtonType } from "@scripts/react/components/Button";
import { ErrorInfo } from "@rapid/components/ErrorInfo";
import { useSignInAndCreateWorkflow } from "@rapid/hooks/useSignInAndCreateWorkflow";

export function GetAPIKeyButton({ showIcon = true }: { showIcon?: boolean } = {}) {
    const { signInAndCreateWorkflow, loading, error } = useSignInAndCreateWorkflow();

    return (
        <>
            {error && (
                <ErrorInfo
                    error={error}
                    retrying={loading}
                    onRetryClick={signInAndCreateWorkflow}
                />
            )}

            <Button
                type="tertiary"
                onClick={signInAndCreateWorkflow}
                loading={loading}
                loadingText="Signing In..."
                className="bg-white"
            >
                {showIcon && <i className="far fa-sparkles" />}
                Sign In
            </Button>
        </>
    );
}
